import { EMOTE_LABELS } from '../emotes'
import styles from '../ui.module.css'

/**
 * The emote buttons for touch (moved from the PHASE1 lobby, T1.9 → PHASE3 T3.2); keys 1–4 send
 * the same emotes (`Session.onKey`). `class` lets the matchmaking screen place and size them.
 */
export function EmoteButtons({
  onEmote,
  class: cls = '',
}: {
  onEmote: (id: number) => void
  class?: string | undefined
}) {
  return (
    <div class={`${styles.emotes} ${cls}`} role="group" aria-label="Emotes">
      {EMOTE_LABELS.map((label, id) => (
        <button
          key={id}
          type="button"
          class={`${styles.button} ${styles.small}`}
          onClick={() => onEmote(id)}
        >
          {label}
        </button>
      ))}
    </div>
  )
}
